/**
 * Video activity validator.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


import BaseValidator from './BaseValidator';
import ValidationResult from './ValidationResult';


const STATE_IDLE = 'idle';
const STATE_ACTIVE = 'active';


export default class VideoActivityValidator extends BaseValidator {
    /**
     * Creates VideoActivityValidator instance.
     *
     * @param {MediaStream} stream Media stream
     * @param {number} interval Check interval
     */
    constructor(stream, { interval = 300 } = {}) {
        super();

        this.stream = stream;
        this.interval = interval;
        this.state = STATE_IDLE;
        this.prevImage = null;
        this.countOfActiveResult = 0;
    }

    /**
     * @override
     * @return {Promise}
     */
    start() {
        this.state = STATE_ACTIVE;

        try {
            return this.stream.getVideoTrack()
                .then((videoTrack) => {
                    const check = () => {
                        videoTrack.getImage()
                            .then((image) => {
                                if (this.state === STATE_IDLE) {
                                    return;
                                }

                                setTimeout(check, this.interval);

                                if (this.prevImage === null) {
                                    this.prevImage = image;
                                    return;
                                }

                                const prevImageView = new Uint32Array(this.prevImage.bytes);
                                const imageView = new Uint32Array(image.bytes);

                                for (let i = 0; i < imageView.length; i++) {
                                    if (imageView[i] !== prevImageView[i]) {
                                        this.countOfActiveResult++
                                        if(this.countOfActiveResult > 2) {
                                            this.emit('result', ValidationResult.OK);
                                        }
                                        this.prevImage = image;
                                        return;
                                    }
                                }

                                this.prevImage = image;
                                this.emit('result', ValidationResult.STILL_IMAGE);
                                this.countOfActiveResult = 0;
                            });
                    };

                    check();
                });
        } catch (e) {
            this.emit('result', ValidationResult.NO_RESULT);

            return Promise.resolve();
        }
    }

    /**
     * @override
     * @return {Promise}
     */
    stop() {
        this.state = STATE_IDLE;

        return Promise.resolve();
    }
}
